import { Component }                              from '@angular/core';
import { NavController, NavParams, Platform }     from 'ionic-angular';
import { LoadingController }                      from 'ionic-angular';
import { dmLoading }                              from '../loading/loading';
import { ExceptionViewModel }                     from './xv-exception';
import { UnhandledExceptionHandler, dmException } from '../../services/UnhandledExceptions';

@Component({
     selector:    'page-exception'
    ,templateUrl: 'exception.html'
})
export class ExceptionPage {
    NewLoading:             (pMessage: string)                             => dmLoading;
    ExitApp:                ()                                             => void;
    CheckForLoggingFailure: ()                                             => boolean;
    SetPageLoaded:          ()                                             => void;
    RemoteLogException:     (pException: dmException, pAction: () => void) => void;

    Exception:              ExceptionViewModel;

    InPage:                 boolean;

    ionViewCanLeave():      boolean { return false; }

    constructor(
         public navCtrl:     NavController
        ,public navParams:   NavParams
        ,public platform:    Platform
        ,public loadingCtrl: LoadingController
    ) {
        console.log('ex page created');
        let exHandler  = navParams.get('exHandler') as UnhandledExceptionHandler;
        let exceptions = exHandler.Exceptions;

        this.NewLoading = (pMessage: string) => {
            let loadingWidget = this.loadingCtrl.create({
                 content:             pMessage
                ,dismissOnPageChange: true
                ,duration:            8000
            });

            let loadingAPI = new dmLoading(
                (pAction: () => void) => {
                    loadingWidget.present().then(() => { pAction(); })
                }
                ,() => {
                    if (this.InPage && (!loadingAPI.IsDismissed)) {
                        loadingWidget.dismiss();
                    }
                }
            );

            loadingWidget.onDidDismiss(() => {
                loadingAPI.IsDismissed = true;
            });

            return loadingAPI;
        };

        this.ExitApp                = () => { platform.exitApp(); };

        this.CheckForLoggingFailure = () => {
            return exHandler.CheckForLoggingFailure();
        };

        this.SetPageLoaded          = () => {
            return exHandler.SetPageLoaded();
        };

        this.RemoteLogException     = (pException: dmException, pAction: () => void) => {
            return exHandler.RemoteLogException(pException, pAction);
        };

        this.Exception              = new ExceptionViewModel(
             this.NewLoading
            ,this.ExitApp
            ,this.CheckForLoggingFailure
            ,this.SetPageLoaded
            ,this.RemoteLogException
            ,exceptions
        );
    }

    ionViewWillEnter() {
        this.InPage = true;
    }

    ionViewWillLeave() {
        this.InPage = false;
    }
}


// WEBPACK FOOTER //
// ./src/pages/exception/exception.ts